export { ArrivedFooterLogo } from './ArrivedFooterLogo';
